var ICON_SIZES = {
  xsmall: 12,
  small: 16,
  medium: 24,
  large: 32
};
var ICON_SIZE_OPTIONS = Object.keys(ICON_SIZES);
var QA_TEST_ID_ATTRIBUTE_NAME = 'data-testid';
export { ICON_SIZES, ICON_SIZE_OPTIONS, QA_TEST_ID_ATTRIBUTE_NAME };